<template>
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10">
        <g fill="none" fill-rule="evenodd" stroke-linecap="round">
            <g stroke="#44B358" stroke-width="2">
                <g>
                    <g>
                        <g>
                            <path d="M.632 5.21L3.159 7.634M3.138 7.651L9.245.589"
                                transform="translate(-872 -394) translate(872 388) translate(0 6) translate(.393 .696)" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'CheckIcon'
}
</script>